import * as React from 'react'
import Checkbox from 'src/components/common/TabSelector/Checkbox'
import EmptyCircle from 'src/components/common/TabSelector/EmptyCircle'
import { colors, heading, mediaQuery, spacing, typographyMixin } from 'src/constants/marketing-ds'
import styled from 'styled-components'

const TabSelector = ({ tabs, activeTab, handleTabClick, tabSavings }) => {
  // Check if there are any savings to display
  const hasSavings = tabSavings && Object.keys(tabSavings).length > 0

  return (
    <StyledTabSelector>
      {tabs?.length > 0 && (
        <div role="tablist" aria-orientation="horizontal" className="plan-tabs-new">
          {tabs.map((tab) => (
            <div className="tab-container" key={tab}>
              {hasSavings && (
                <div className="tab-note">{tabSavings?.[tab.toLowerCase()] || <>&nbsp;</>}</div>
              )}
              <button
                aria-controls={`tab-${tab}`}
                aria-selected="true"
                tabIndex="0"
                role="tab"
                onClick={() => handleTabClick(tab)}
                className={activeTab.toLowerCase() === tab.toLowerCase() ? 'active' : ''}
              >
                <div className="tab-content">
                  <div className="tab-length">
                    {tab}
                    {tabSavings?.[tab.toLowerCase()] && (
                      <div className="tab-note-mobile">{tabSavings?.[tab.toLowerCase()]}</div>
                    )}
                  </div>
                  <div className="tab-icon">
                    {activeTab.toLowerCase() === tab.toLowerCase() ? <Checkbox /> : <EmptyCircle />}
                  </div>
                </div>
              </button>
            </div>
          ))}
        </div>
      )}
    </StyledTabSelector>
  )
}

export default TabSelector

const StyledTabSelector = styled.div`
  .plan-tabs-new {
    margin: 0 auto;
    display: flex;
    width: 100%;

    max-width: 800px;
    gap: ${spacing.xxs};

    ${mediaQuery.mobileMax} {
      gap: ${spacing.sm};
    }

    .tab-container {
      flex: 1 0 0;
      display: flex;
      flex-direction: column;

      .tab-note {
        ${typographyMixin(heading.sm)}
        font-weight: 700;
        text-align: center;
        margin-bottom: ${spacing.xxxs};
        color: ${colors.mint[120]};
      }

      .tab-note-mobile {
        font-size: 14px;
        text-align: center;
        font-weight: 500;
        display: none;
        @media (min-width: 481px) {
          display: none;
        }
      }

      button {
        ${'' /* Reset Button CSS */}
        border: none;
        margin: 0;
        padding: ${spacing.sm} 0;
        overflow: visible;
        background: transparent;
        -webkit-font-smoothing: inherit;
        -moz-osx-font-smoothing: inherit;
        -webkit-appearance: none;
        ${mediaQuery.mobileMax} {
          padding: ${spacing.sm} ${spacing.lg};
        }
        &::-moz-focus-inner {
          border: 0;
          padding: 0;
        }

        cursor: pointer;
        background: #ffffff;
        color: #000;
        border-radius: 50px;
        width: 100%;

        @media (max-width: 599px) {
          border-radius: 10px;
        }

        &:hover {
          background: #f0f0f0;
        }

        &.active {
          box-shadow: 0 0 0 3px ${colors.orange[100]};
        }

        .tab-content {
          ${typographyMixin(heading.xs)}
          text-transform: capitalize;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          gap: ${spacing.xxxxs};
          ${mediaQuery.mobileMax} {
            gap: ${spacing.xxxs};

            ${typographyMixin(heading.sm)}
            flex-direction: row;
          }

          .tab-icon {
            height: 24px;
          }
        }
      }
    }
  }
`
